import { useUrlFilterController } from 'app/components/filters/url-filters';

import { FilterAdapter } from './url-filters';
import { useMemo } from 'react';
import Select from 'react-select';
import { AppsFiltersStyles } from 'app/components/common/common-styles';

export type EntityType = 'task' | 'deal';
export const EntityTypeAdapter: FilterAdapter<EntityType> = {
  key: 'entity_type',
  fromUrl: (sp) => {
    const raw = sp.get('entity_type');
    return raw === 'task' || raw === 'deal' ? raw : null;
  },
  toUrl: (sp, value) => {
    const next = new URLSearchParams(sp.toString());
    if (!value) next.delete('entity_type');
    else next.set('entity_type', value);
    return next;
  },
  toKey: (v) => `entity:${v ?? 'all'}`
};

type EntityTypeFilterProps = {
  placeholder?: string;
} & Record<string, any>;

export function EntityTypeFilter({ placeholder = 'All sources', props }: EntityTypeFilterProps) {
  const ctl = useUrlFilterController();
  const value = ctl.get(EntityTypeAdapter);

  const options = useMemo(
    () => [
      { value: 'task' as EntityType, label: 'My Tasks' },
      { value: 'deal' as EntityType, label: 'Partners Tasks' }
    ],
    []
  );

  const selected = options.find((o) => o.value === value) ?? null;

  return (
    <Select
      styles={AppsFiltersStyles()}
      {...props}
      isClearable
      isSearchable={false}
      options={options}
      value={selected}
      placeholder={placeholder}
      onChange={(opt: any) => ctl.set(EntityTypeAdapter, opt?.value ?? null)}
    />
  );
}
